import { Component, Input } from '@angular/core';
import { environment } from 'src/environments/environment';
import { MediaService } from 'src/app/shared/services/media.service';

@Component({
  selector: 'app-open-employee-manage',
  templateUrl: './open-employee-manage.component.html',
  styleUrls: ['./open-employee-manage.component.scss']
})
export class OpenEmployeeManageComponent {

  constructor(private mediaService: MediaService) { }

  @Input() employeeId:number;


  showEmployee() {
    let webAppPath = '';
    if(environment.wepAppName){
      webAppPath = "/" + environment.wepAppName;
    }
    
   const documentLink = window.location.origin + webAppPath + '/adminCenter/users/employee/' + this.employeeId + '/manage';
    const width = this.mediaService.getFullHdRelativeWidth(1);
    const height = this.mediaService.getFullHdRelativeHeight(1);
    window.open(documentLink, "_employeeManageViewer", 'width=' + width + ',height=' + height + ',toolbar=0,location=0,resizable=1,scrollbars=1'); return false;
  }

}
